import { Avatar, Field, Label, makeStyles, Switch, Tag, Textarea } from "@fluentui/react-components";
import type { EAppId, ICreateConfigurationInfo, IGroupDetail, IUserDetail } from "../../../../interfaces";
import { SimpleSettingsDataView } from "./SimpleSettingsDataView/SimpleSettingsDataView";

export interface IConfirmCreateSettingsProps {
    settingsInfo: ICreateConfigurationInfo;
    usersToBeAdded: IUserDetail[];
    groupsToBeAdded: IGroupDetail[];
    onEnabledChange(isEnabled: boolean): void;
    onDescriptionChange(description: string): void;
}

const useStyles = makeStyles({
    containerDiv: {
        paddingBottom: '20px'
    },
    addUsersDiv: {
        paddingBottom: '20px'
    },
    field: {
        marginBottom: '20px'
    },
    innerFieldDiv: {
        marginTop: '10px'
    },
    textArea: {
        maxWidth: '600px'
    }
});

export const ConfirmCreateSettings = (props: IConfirmCreateSettingsProps) => {
    const { settingsInfo, usersToBeAdded, groupsToBeAdded, onEnabledChange, onDescriptionChange } = props;
    const styles = useStyles();

    const renderAssignedUsers = () => {
        return (
            <>
                {usersToBeAdded.length > 0 &&
                    <div className={styles.addUsersDiv} key={'users-div-outer'}>
                        <Field label="Users to be added" size="medium">
                            <div className={styles.innerFieldDiv} key={'users-div'}>
                                {usersToBeAdded.map((item) => (
                                    <div key={`user-div-${item.id}`}>
                                        <Tag key={`user-tag-${item.id}`} shape="circular" value={item.id} media={<Avatar name={item.displayName} />}>
                                            {item.displayName}
                                        </Tag>
                                    </div>
                                ))}
                            </div>
                        </Field>
                    </div>}
                {groupsToBeAdded.length > 0 &&
                    <div className={styles.addUsersDiv} key={'groups-div-outer'}>
                        <Field label="Groups to be added" size="medium">
                            <div className={styles.innerFieldDiv} key={'groups-div'}>
                                {groupsToBeAdded.map((item) => (
                                    <div key={`group-div-${item.id}`}>
                                        <Tag key={`group-tag-${item.id}`} shape="circular" value={item.id} media={<Avatar name={item.displayName} />}>
                                            {item.displayName}
                                        </Tag>
                                    </div>
                                ))}
                            </div>
                        </Field>
                    </div>}
                {groupsToBeAdded.length === 0 && usersToBeAdded.length === 0 && <Label size="medium">Entire organization </Label>}
            </>
        );
    };

    return (
        <div className={styles.containerDiv}>
            <h3>Review and finish</h3>
            <Field label={"Settings"} size="large" className={styles.field}>
                <SimpleSettingsDataView applicationId={settingsInfo.appId as EAppId} settingsData={settingsInfo.settingsData} />
            </Field>
            <Field label={"Assigned users"} size="large" className={styles.field}>
                {renderAssignedUsers()}
            </Field>
            <Field label={"Deploy configuration"} size="large" className={styles.field}>
                <Field label={settingsInfo?.isEnabled ? "Configuration will be deployed" : "Configuration will be saved but not deployed"} orientation="horizontal">
                    <Switch
                        checked={settingsInfo?.isEnabled}
                        onChange={(_, data) => onEnabledChange(data.checked)}
                    />
                </Field>
            </Field>
            <Field label={"Description"} size="large" className={styles.field}>
                <Textarea
                    size="medium"
                    className={styles.textArea}
                    placeholder="Add a description to your configuration."
                    resize="vertical"
                    value={settingsInfo?.description}
                    onChange={(_, data) => onDescriptionChange(data.value)} />
            </Field>
        </div>
    );
};